import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormChipInputField, {
  MxFormChipInputFieldProps
} from "@rf-l2/form/text-fields/MxFormChipInput";
import MxFormInputField, {
  MxFormInputFieldProps
} from "@rf-l2/form/text-fields/MxFormInputField";
import { memo } from "react";
interface MxFormL3ChipInputFieldProps extends MxFormChipInputFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3ChipInputField = (props: MxFormL3ChipInputFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormChipInputField label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3ChipInputField;
